<template>
    <div class="section">
        <div class="center-section">
            <div class="form-heading">
                <p class="header-1">
                    {{ $t('auth.reset.success') }}
                </p>

                <p class="caption">
                    {{ $t('auth.reset.successDescription') }}
                </p>
            </div>

            <div class="login-link caption">
                <router-link    to="/login" 
                                class="link">
                                {{ $t('auth.reset.backToLogin') }}
                </router-link>
            </div>
        </div>
    </div>

</template>

<script setup>
</script>

<style scoped>
    .center-section {
        width: 35%;
        margin: auto;
    }

    .form-heading {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding-bottom: var(--spacing-xl);
    }

    .form-heading .caption {
        color: var(--color-white-40);
        text-align: center;
    }

    .form-heading img {
        max-width: 100%;
        height: auto;
        object-fit: contain;
    }

    .signup-form {
        padding: var(--spacing-2xl);
        margin-bottom: var(--spacing-lg);
        background-color: var(--bg-card);
        border-radius: var(--border-radius-2xl);
    }

    .login-link {
        text-align: center;
        color: var(--color-white-40);
    }

    .link {
        color: var(--color-white);
        text-decoration: none;
    }

    .header-1 {
        text-align: center;
    }
</style>
